export default "__VITE_ASSET__DruBfpcs__"